import config from '@/common/config'
import { ModelApiService } from './BaseApiService'

export default class FormTemplatesApiService extends ModelApiService {
  constructor() {
    super(
      'forms',
      `${config.get('forms2.api.url')}v${config.get('forms2.api.version')}/`,
      config.get('forms2.api.version')
    )
  }

  async getFormLatestVersion(formTemplateId) {
    return await this.get(`${formTemplateId}`)
  }
}
